import React from 'react'
import { type RecurringRepairSubscription } from '../types/recurring-repair.types'
import { Trans, useTranslation } from 'react-i18next'

type Props = {
    subscription: RecurringRepairSubscription
}

export default function Intro({subscription}: Props) {
    const { t } = useTranslation('checkout');
    let content = <></>;

    if (!subscription){
        return content;
    }

    if (subscription.paymentMethodId != null){
        content = (
            <span>
            <Trans t={t} i18nKey='subscription.introWithCard'>
                Thank you for using our Boris FX Products! Your subscription 
                is currently active, and will renew automatically. If you wish to 
                select a new payment method, please visit your <a href="/acccount/manage">Account Page.</a>
            </Trans>
            </span>
        )
    }
    else{
        content = <span>{t('subscription.introNoCard')}</span>
    }


  return (
    <div>
        {content}
    </div>
  )
}